import { Table, Text } from '@quintoandar-tokko/jopijs';
import styles from '../dashboardTables.module.scss';
import PropertyOrDevelopmentCell from '../components/PropertyOrDevelopmentCell';
import AgentBranchCell from '../components/AgentBranchCell';

export default function DevelopmentConsultationsTableRow({ row }) {
  const {
    development,
    agents_in_charge,
    development_type,
    inquiry,
    units,
    construction_status,
    id,
  } = row;

  return (
    <Table.RowDefault id={id} variant="secondary">
      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <PropertyOrDevelopmentCell
          id={development?.id}
          thumbnail={development?.thumbnail}
          address={development?.name}
          location={development?.location}
          modal="developmentConsultations"
          isDevelopment
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <Text variant="body.fontSize13">{development_type}</Text>
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <Text variant="body.fontSize13">{construction_status}</Text>
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <Text variant="body.fontSize13">{`${units.available}/${units.total}`}</Text>
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        {agents_in_charge.map((agent) => (
          <AgentBranchCell
            key={agent.id}
            agentId={agent.id}
            agentName={agent.name}
            branchName={agent.branch_name}
            image={agent.profile_picture}
            relativeSelector="#development-consultations-modal"
            withBranch
            withBoldTitle
            modal="developmentConsultations"
          />
        ))}
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <Text variant="body.fontSize13" className={styles.textToRight}>
          {inquiry}
        </Text>
      </Table.RowItemDefault>
    </Table.RowDefault>
  );
}
